import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import api from "../../../api";
import useCommonDropdowns from "../../../hooks/useCommonDropdowns";
import DropdownField from "../../../components/DropdownField";
import InputField from "../../../components/InputField";
import TextareaField from "../../../components/TextareaField";
import BooleanSelectField from "../../../components/BooleanSelectField";
import SubmitButton from "../../../components/SubmitButton";

const dropdownParams = [
  "Genders",
  "Months",
  "Years",
  "Days",
  "Regions",
  "TargetSchools",
  "SchoolYears",
];


const AddStudent = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { dropdowns, loading: dropdownLoading } = useCommonDropdowns(
    dropdownParams
  );

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      // email: "", // Commented out to remove prefilled data
      // password: "", // Commented out to remove prefilled data
      // password_confirmation: "", // Commented out to remove prefilled data
      year_id: "",
      month_id: "",
      day_id: "",
      school_year_id: "",
      region_id: "",
      gender_id: "",
      target_school_id: "",
      // display_name: "",
      // show_answer_after_n_attempts: 1,
      // NOTE: not used in parent/student/add API
      // can_change_password: false,  
      notes: "",
    },
  });


  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await api.post("parent/add/student", data);
      toast.success("Student created successfully!");
      reset();
      // Redirect to student list after successful creation
      navigate("/parent/my-student-list");
    } catch (err) {
      const backendErrors = err.response?.data?.errors;
      if (backendErrors) {
        Object.entries(backendErrors).forEach(([field, messages]) => {
          setError(field, {
            type: "server",
            message: messages[0],
          });
        });
      } else {
        const message = err.response?.data?.message || "Something went wrong";
        toast.error(message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>
        Add New Student
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          {/* <InputField
            control={control}
            name="email"
            label="Email"
            type="email"
            error={errors.email}
            loading={dropdownLoading}
            required={true}
          />
          {/* <InputField
            control={control}
            name="password"
            label="Password"
            type="password"
            error={errors.password}
            loading={dropdownLoading}
            required={true}
          />
          <InputField
            control={control}
            name="password_confirmation"
            label="Confirm Password"
            type="password"
            error={errors.password_confirmation}
            loading={dropdownLoading}
            required={true}
          /> */}
          {/* <InputField
            control={control}
            name="display_name"
            label="Display Name"
            error={errors.display_name}
            loading={dropdownLoading}
            required={true}
          /> */}
          <InputField
            control={control}
            name="first_name"
            label="First Name"
            error={errors.first_name}
            loading={dropdownLoading}
            required={true}
          />
          <InputField
            control={control}
            name="last_name"
            label="Last Name"
            error={errors.last_name}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="gender_id"
            label="Gender"
            options={dropdowns.Genders || []}
            error={errors.gender_id}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="year_id"
            label="Birth Year"
            options={dropdowns.Years || []}
            error={errors.year_id}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="month_id"
            label="Month"
            options={dropdowns.Months || []}
            error={errors.month_id}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="day_id"
            label="Day"
            options={dropdowns.Days || []}
            error={errors.day_id}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="school_year_id"
            label="School Year"
            options={dropdowns.SchoolYears || []}
            error={errors.school_year_id}
            loading={dropdownLoading}
            required={true}
          />
          <DropdownField
            control={control}
            name="target_school_id"
            label="Target School"
            options={dropdowns.TargetSchools || []}
            error={errors.target_school_id}
            loading={dropdownLoading}
            required={true}
          />

          {/* <InputField
            control={control}
            name="show_answer_after_n_attempts"
            label="Show Answer After N Attempts"
            type="number"
            error={errors.show_answer_after_n_attempts}
            loading={dropdownLoading}
          /> */}

          {/* <BooleanSelectField
            control={control}
            name="allow_view_examiner_report_for_mocks"
            label="Allow View Examiner Report For Mocks"
            error={errors.allow_view_examiner_report_for_mocks}
            loading={dropdownLoading}
          /> */}

          {/* <BooleanSelectField
            control={control}
            name="can_change_password"
            label="Can Change Password"
            error={errors.can_change_password}
            loading={dropdownLoading}
          /> */}


          <TextareaField
            control={control}
            name="notes"
            label="Notes"
            error={errors.notes}
            loading={dropdownLoading}
          />

          <SubmitButton
            loading={loading}
            label="Add Student"
          />

        </Grid>
      </form>
    </Box>
  );
};

export default AddStudent;
